import { render, staticRenderFns } from "./storeOrderCart.vue?vue&type=template&id=c4538c3c&scoped=true"
import script from "./storeOrderCart.vue?vue&type=script&lang=js"
export * from "./storeOrderCart.vue?vue&type=script&lang=js"
import style0 from "./storeOrderCart.vue?vue&type=style&index=0&id=c4538c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4538c3c",
  null
  
)

export default component.exports